import { LocalStorageKeyName } from 'enums/LocalStorageKeyName';

export const getLocalStorageItem = (key: LocalStorageKeyName) => {
  const data = localStorage.getItem(key);

  return data && JSON.parse(data);
};
